export const AVATAR_WIDTH_PX = 24
export const AVATAR_HEIGHT_PX = 24
